export const clinic_features_list = [
    { value: 'Dental anxiety friendly', label: 'Dental anxiety friendly' },
    { value: 'Free parking', label: 'Free parking' },
    { value: 'Financing plans', label: 'Financing plans' },
    { value: 'Free coffe or beverages', label: 'Free coffe or beverages' },
    { value: 'Kid friendly', label: 'Kid friendly' },
    { value: 'Noise cancelling headphones', label: 'Noise cancelling headphones' },
    { value: 'Sedation', label: 'Sedation' },
    { value: 'Wifi', label: 'Wifi' },
    { value: 'Public transit accessible', label: 'Public transit accessible' },
  ];

